export default __webpack_public_path__ + "static/media/footer-blue-bg.c78a7691.svg";